import script from "./MpgsSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./MpgsSuccess.vue?vue&type=script&setup=true&lang=js"

import "./MpgsSuccess.vue?vue&type=style&index=0&id=59b478d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59b478d4"]])

export default __exports__